<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="bg-color-blue-200--20 u-padding-16 u-borderRadius--4px"
>
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="color-blue">info</mat-icon>
    <span class="u-marginLeft-8" i18n="@@setupRedirectBanner.prompt">
      There are still items to review before your Hub is ready</span
    >
  </div>
  <a
    class="color-blue"
    [routerLink]="routerLink"
    i18n="@@setupRedirectBanner.cta"
  >
    Return to the Hub setup guide
  </a>
</div>
